import React from "react"
import { NavLink } from "react-router-dom"
import { View, Text, Window, Grid, Col } from "react-ame-components"

export default class Showcase extends React.Component {
  render() {
    return (
      <Window>
        <View padding="large">
          <View
            direction="column"
            padding="small"
            borderRadius="small"
            shadow="level-2"
            backgroundColor="neutral-100">
            <Text
              fontSize="medium"
              fontWeight="bold">
              {this.props.title}
            </Text>
            <View martinTop="small">
              <Text fontSize="small">{this.props.description}</Text>
            </View>
            {this.props.skipBackButton ? null : (
              <NavLink
                style={{ padding: 1, display: "inline-block" }}
                to={"/"}>
                Voltar para a lista de componentes
              </NavLink>
            )}
            {this.props.centerGrid ? (
              <View marginTop="medium">
                <Grid>
                  <Col columnSize={{ sm: 12, lg: 3 }}></Col>
                  <Col columnSize={{ sm: 12, lg: 6 }}>
                    <View direction="column">{this.props.children}</View>
                  </Col>
                  <Col columnSize={{ sm: 12, lg: 3 }}></Col>
                </Grid>
              </View>
            ) : (
              this.props.children
            )}
          </View>
        </View>
      </Window>
    )
  }
}
